import { render, staticRenderFns } from "./TemplateOne.vue?vue&type=template&id=20207bce&scoped=true&"
import script from "./TemplateOne.vue?vue&type=script&lang=js&"
export * from "./TemplateOne.vue?vue&type=script&lang=js&"
import style0 from "./TemplateOne.vue?vue&type=style&index=0&id=20207bce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20207bce",
  null
  
)

export default component.exports